import companyApi from './company-api';

export * from './models';

export default companyApi;
